const autoNgTemplateLoaderTemplate1 = require('./containerGroupsDatatable.html');

angular.module('shbdeployer.azure').component('containergroupsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
